import Header from '@/components/feature/Header';
import HeroSection from './components/HeroSection';
import TopicsSection from './components/TopicsSection';
import CardsSection from './components/CardsSection';
import CarouselSection from './components/CarouselSection';
import ContactSection from './components/ContactSection';
import CommentsSection from './components/CommentsSection';
import FeaturesSection from './components/FeaturesSection';
import AppSection from './components/AppSection';
import AboutSection from './components/AboutSection';
import UpdatesSection from './components/UpdatesSection';
import IndexSection from './components/IndexSection';
import MediaSection from './components/MediaSection';
import RankingSection from './components/RankingSection';
import FAQSection from './components/FAQSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <HeroSection />
        <TopicsSection />
        <CardsSection />
        <CarouselSection />
        <ContactSection />
        <CommentsSection />
        <FeaturesSection />
        <AppSection />
        <AboutSection />
        <UpdatesSection />
        <IndexSection />
        <MediaSection />
        <RankingSection />
        <FAQSection />
      </main>
      <Footer />
    </>
  );
}